import {SiteConfigContextValue} from '@common/core/settings/site-config-context';
import {CommonUploadType} from '@common/uploads/common-upload-type';
import {message} from '@ui/i18n/message';

export const SiteConfig: Partial<SiteConfigContextValue> = {
  roles: {
    types: [
      {
        type: 'users',
        label: message('Customers'),
        permission_type: 'customers',
      },
      {
        type: 'agents',
        label: message('Agents'),
        permission_type: 'agents',
      },
    ],
  },
};

export const UploadType = {
  conversationAttachments: 'conversationAttachments',
  articleAttachments: 'articleAttachments',
  conversationImages: 'conversationImages',
  aiDocuments: 'aiDocuments',
  applicationDocuments: 'applicationDocuments',
  ...CommonUploadType,
} as const;
